// initial state
const state = {
  options: {
    sex: [
      {label: '男', value: 1},
      {label: '女', value: 2},
    ],
    age: [
      {label: '<20', value: 1},
      {label: '20-25', value: 2},
      {label: '26-35', value: 3},
      {label: '36-45', value: 4},
      {label: '>45', value: 5},
    ],
    education: [
      {label: '小学', value: 1},
      {label: '初中', value: 2},
      {label: '高中', value: 3},
      {label: '大专', value: 4},
      {label: '本科', value: 5},
      {label: '本科以上', value: 6},
    ],
    marriage: [
      {label: '已婚已育', value: 1},
      {label: '已婚未育', value: 2},
      {label: '未婚', value: 3},
    ],
    height: [
      {label: '<160', value: 1},
      {label: '160-165', value: 2},
      {label: '166-170', value: 3},
      {label: '171-175', value: 4},
      {label: '>176', value: 5},
    ],
    weight: [
      {label: '<100', value: 1},
      {label: '101-150', value: 2},
      {label: '151-180', value: 3},
      {label: '>180', value: 4},
    ],
    transport_mode: [
      {label: '需要有车', value: 1},
    ],
  },
  platformTypes: [
    0, // 主平台任务
    1, // 查理宝任务
    2, // 标注任务
    3, // TEKE平台任务
    6, // 中台任务
  ]
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const task = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/task/task.store.js